module.exports = __webpack_public_path__ + "img/logo.17f87c8b.png";